import { Canceler } from "axios";
import { EntityApi } from "../../services/ApiPlatform";
import { FinalResponse, ListResponse } from "../../services/ApiPlatform/models";
import { PrimitiveObject } from "../../services/ApiPlatform/types";

export abstract class InternshipScheduleApi extends EntityApi {
    protected static GET_COLLECTION = "/api/internship-schedules";

    protected static POST_COLLECTION = "/api/internship-schedules";

    protected static GET_ITEM = "/api/internship-schedules/{id}";

    protected static PUT_ITEM = "/api/internship-schedules/{id}";

    protected static PATCH_ITEM = "/api/internship-schedules/{id}";

    protected static DELETE_ITEM = "/api/internship-schedules/{id}";

    protected static GET_AVAILABLE_SEATS =
        "/api/internship-schedules/{id}/get-available-seats/{seatId}";

    protected static POST_SCHEDULE_CLONE = "/api/internship-schedules/clone";

    protected static POST_SKILL_REPORT =
        "/api/internship-schedules/skill-report";

    protected static GET_COLLECTION_FOR_SCHEDULER =
        "/api/internship-schedules/for-scheduler";

    protected static GET_COLLECTION_FOR_SCHEDULER_WITH_SEAT =
        "/api/internship-schedules/for-scheduler-with-seat";

    public static async getAvailableSeats<R>(
        id: number | string,
        seatId: number | string,
        extraParams: PrimitiveObject = {}
    ): Promise<FinalResponse<R | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.routeToPath(this.GET_AVAILABLE_SEATS, {
                id,
                seatId,
            }),
        };
        return this.getItem(id, extraParams);
    }

    public static async postScheduleClone<R, P>(
        entity: P,
        extraParams = {}
    ): Promise<FinalResponse<R | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.POST_SCHEDULE_CLONE,
        };
        return this.postCollection(entity, extraParams);
    }

    public static async postCollectionSkillReport<R, P>(
        entity: P,
        extraParams = {}
    ): Promise<FinalResponse<R | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.POST_SKILL_REPORT,
        };
        return this.postCollection(entity, extraParams, {
            responseType: "blob",
        });
    }

    public static async getCollectionForScheduler<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_FOR_SCHEDULER,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }

    public static async getCollectionForSchedulerWithSeat<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_FOR_SCHEDULER_WITH_SEAT,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }
}
